import { render, staticRenderFns } from "./ElSelectTable.vue?vue&type=template&id=ba667152&scoped=true&"
import script from "./ElSelectTable.vue?vue&type=script&lang=js&"
export * from "./ElSelectTable.vue?vue&type=script&lang=js&"
import style0 from "./ElSelectTable.vue?vue&type=style&index=0&id=ba667152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba667152",
  null
  
)

export default component.exports